import React from 'react';
import Skeleton from '../../../common/skeleton';
import { Row, Col } from 'react-bootstrap';

const AffiliatedDoctorsSkeleton = () => {
  return (
    <>
      <Row className="mr-4">
        {[1, 2, 3].map((item, index) => (
          <Col sm={12} className="each-doctor" key={index}>
            <p className="provider-details-heading">
              <Skeleton count={1} containerClassName={'affiliated-doctors'} />
            </p>
            <p className="provider-details-data ml-0">
              <Skeleton count={1} containerClassName={'affiliated-doctors'} />
            </p>
            <p className="provider-details-data ml-0">
              <Skeleton count={1} containerClassName={'affiliated-doctors'} />
            </p>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default AffiliatedDoctorsSkeleton;
